export const ACTIONS_ACCOUNT = {
  INVALIDATE: 'ACCOUNTS_INVALIDATE',
  RECEIVE: 'ACCOUNTS_RECEIVE',
  DELETE: 'ACCOUNT_DELETE',
  UPDATE: 'ACCOUNT_UPDATE',
};

const accountConstants = {};

export default accountConstants;
